import React from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import PDCReportDocument from "./PDCReportDocument";
import Modal from "../common/CommonModal";
import PDCIssuedDocument from "./PDCIssuedDocument";

const PDCIssuedPrint = ({ pdcIssuedPrintDataFromAPI, setIsPDCIssuedPrint , isPDCIssuedPrint }) => {
  const onClose = () => {
    setIsPDCIssuedPrint(false);
  };

  console.log("pdcIssuedPrintDataFromAPI:", pdcIssuedPrintDataFromAPI);
  return (
    <Modal
      isOpen={isPDCIssuedPrint}
      onClose={() => setIsPDCIssuedPrint(false)}
      title={"PDC Issuedd"}
      size="xxl"
      header={true}
    >
      <div className="flex flex-col items-center h-screen">
        <div className="w-full h-[82vh] border border-gray-300 mb-4">
          <PDFViewer width="100%" height="100%">
            <PDCIssuedDocument pdcIssuedPrintDataFromAPI={pdcIssuedPrintDataFromAPI} />
          </PDFViewer>
        </div>
      </div>
    </Modal>
  );
};

export default PDCIssuedPrint;
